import { useEffect } from "react";
import ListUsers from "../components/Users/ListUsers";

import styles from "./css/usersList.module.css"

export default function UsersList({ setHeader }) {

    useEffect(() => {
        setHeader(true)
    }, []);

    return (
        <div className={styles.tableContainer}>
            <ListUsers />
        </div>

    );
}